module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_it-26cb5b1a.png";